import React from "react";
import { useSetBaggage } from "./baggage";

/**
 * BaggageBoundary sets/merges the provided baggage values for the lifetime
 * of its children and restores previous values on unmount.
 *
 * It does not provide a React Context; it scopes baggage changes.
 */
export function BaggageBoundary({
  values = {},
  children,
}: {
  values?: Record<string, string>;
  children: React.ReactNode;
}) {
  useSetBaggage(values);
  return children;
}
